// src/app/SapHorario/index.jsx
import React, { useState, useEffect, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from '../../services/api.js';
import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer/index.jsx";
import Swal from 'sweetalert2';
import { 
  FaClock, 
  FaSave, 
  FaArrowLeft, 
  FaCalendarAlt, 
  FaExclamationTriangle,
  FaCheck
} from "react-icons/fa";
import './index.css';

function SapSol() {
    const [listaHorario, setListaHorario] = useState([]);
    const [loading, setLoading] = useState(true);
    const [salvandoIndex, setSalvandoIndex] = useState(null);

    const navigate = useNavigate();
    const chapa = localStorage.getItem("chapa");

    // Redireciona se não houver funcionário logado
    useEffect(() => {
        if (!chapa) {
            navigate("/arbor/login");
        }
    }, [chapa, navigate]);

    // Carrega dados de horários do SAP
    const carregarDadosHorario = useCallback(() => {
        if (!chapa) return;
        setLoading(true);

        api.get('/SAP/horario/' + chapa)
            .then(retorno => {
                setListaHorario(Array.isArray(retorno.data) ? retorno.data : []);
            })
            .catch(err => {
                console.error("Erro ao carregar horários:", err);
                Swal.fire({
                    icon: 'error',
                    title: 'Erro de Conexão',
                    text: 'Não foi possível carregar a lista de horários.',
                    confirmButtonColor: '#991b1b'
                });
            })
            .finally(() => {
                setLoading(false);
            });
    }, [chapa]);

    useEffect(() => {
        carregarDadosHorario();
    }, [carregarDadosHorario]);

    // Manipuladores de Input
    const handleAberturaChange = (abertura, index) => {
        const loc = [...listaHorario];
        loc[index].abertura = abertura;
        setListaHorario(loc);
    };

    const handleFechamentoChange = (fechamento, index) => {
        const loc = [...listaHorario];
        loc[index].fechamento = fechamento;
        setListaHorario(loc);
    };

    // Altera Horário Individual
    const alterarHorario = (parametro, abertura, fechamento, index) => {
        if (!abertura || !fechamento) {
            Swal.fire({
                icon: 'warning',
                title: 'Campos Incompletos',
                text: 'Por favor, preencha os horários de abertura e fechamento.',
                confirmButtonColor: '#991b1b'
            });
            return;
        }

        setSalvandoIndex(index);

        api.post(`/SAP/horario?param=${parametro}&abertura=${abertura}&fechamento=${fechamento}`)
            .then(() => {
                Swal.fire({
                    icon: 'success',
                    title: 'Horário Atualizado!',
                    text: 'Gravação efetuada com sucesso.',
                    timer: 1500,
                    showConfirmButton: false,
                    customClass: { popup: 'rounded-4' }
                });
                carregarDadosHorario();
            })
            .catch((err) => {
                console.error("Erro ao alterar horário:", err);
                Swal.fire({
                    icon: 'error',
                    title: 'Falha na Gravação',
                    text: err.response?.data?.erro || 'Erro ao registrar alteração.',
                    confirmButtonColor: '#991b1b'
                });
            })
            .finally(() => {
                setSalvandoIndex(null);
            });
    };

    return (
        <div className="sapsol-page-wrapper">
            <Menu modulo="SAP" />

            <div className="container-fluid px-3 px-md-4 mt-4 max-width-container pb-5">
                <div className="row justify-content-center">
                    <div className="col-lg-8 col-xl-7">
                        
                        {/* CABEÇALHO DO MÓDULO */}
                        <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 pb-2 border-bottom gap-2">
                            <div>
                                <h5 className="fw-bold m-0 text-dark d-flex align-items-center gap-2">
                                    <FaClock className="text-custom-red" />
                                    Horários de Funcionamento (SAP)
                                </h5>
                                <span className="small text-muted">
                                    Defina as janelas de abertura e fechamento para solicitações.
                                </span>
                            </div>

                            <Link to="/arbor/sap/" className="btn btn-outline-secondary btn-sm fw-semibold rounded-3 d-flex align-items-center gap-2">
                                <FaArrowLeft /> Voltar
                            </Link>
                        </div>

                        {/* SPINNER LOADING */}
                        {loading && (
                            <div className="text-center py-5">
                                <div className="spinner-border text-custom-red" role="status" style={{ width: '2.5rem', height: '2.5rem' }}>
                                    <span className="visually-hidden">A carregar...</span>
                                </div>
                                <div className="text-muted fw-semibold mt-2 small">Buscando configuração de horários...</div>
                            </div>
                        )}

                        {/* TABELA DESKTOP */}
                        {!loading && listaHorario.length > 0 && (
                            <div className="card border-0 shadow-sm rounded-4 overflow-hidden mb-4 d-none d-md-block">
                                <div className="table-responsive">
                                    <table className="table table-hover align-middle m-0 sapsol-table">
                                        <thead>
                                            <tr>
                                                <th className="text-center" style={{ width: '70px' }}>Dia</th>
                                                <th>Dia da Semana</th>
                                                <th className="text-center" style={{ width: '150px' }}>Abertura</th>
                                                <th className="text-center" style={{ width: '150px' }}>Fechamento</th>
                                                <th className="text-center" style={{ width: '100px' }}>Ação</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {listaHorario.map((horario, index) => (
                                                <tr key={horario.dia || index}>
                                                    <td className="text-center fw-bold text-secondary">
                                                        {horario.dia}
                                                    </td>
                                                    <td className="fw-semibold text-dark">
                                                        <div className="d-flex align-items-center gap-2">
                                                            <FaCalendarAlt className="text-muted" />
                                                            {horario.diasemana}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <input 
                                                            type="time" 
                                                            value={horario.abertura || ""}
                                                            onChange={(e) => handleAberturaChange(e.target.value, index)}
                                                            className="form-control form-control-sm text-center fw-semibold rounded-3 input-time-custom"
                                                        />
                                                    </td>
                                                    <td>
                                                        <input 
                                                            type="time" 
                                                            value={horario.fechamento || ""}
                                                            onChange={(e) => handleFechamentoChange(e.target.value, index)}
                                                            className="form-control form-control-sm text-center fw-semibold rounded-3 input-time-custom"
                                                        />
                                                    </td>
                                                    <td className="text-center">
                                                        <button 
                                                            type="button" 
                                                            onClick={() => alterarHorario(horario.parametro, horario.abertura, horario.fechamento, index)} 
                                                            className="btn btn-custom-red btn-sm fw-bold px-3 rounded-3"
                                                            disabled={salvandoIndex === index}
                                                            title="Salvar Horário"
                                                        >
                                                            {salvandoIndex === index ? (
                                                                <span className="spinner-border spinner-border-sm" role="status"></span>
                                                            ) : (
                                                                <>
                                                                    <FaSave className="me-1" /> Salvar
                                                                </>
                                                            )}
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}

                        {/* LISTAGEM EM CARDS MOBILE */}
                        {!loading && listaHorario.length > 0 && (
                            <div className="d-md-none mb-4">
                                {listaHorario.map((horario, index) => (
                                    <div key={horario.dia || index} className="card border-0 shadow-sm rounded-3 mb-3 p-3 bg-white">
                                        <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-2">
                                            <span className="fw-bold text-dark d-flex align-items-center gap-2">
                                                <FaCalendarAlt className="text-custom-red" />
                                                {horario.diasemana}
                                            </span>
                                            <span className="badge bg-light text-dark border fw-semibold">
                                                Dia {horario.dia}
                                            </span>
                                        </div>

                                        <div className="row g-2 mb-3">
                                            <div className="col-6">
                                                <label className="x-small fw-bold text-muted text-uppercase d-block mb-1">Abertura:</label>
                                                <input 
                                                    type="time" 
                                                    value={horario.abertura || ""}
                                                    onChange={(e) => handleAberturaChange(e.target.value, index)}
                                                    className="form-control form-control-sm text-center fw-semibold rounded-3 input-time-custom"
                                                />
                                            </div>
                                            <div className="col-6">
                                                <label className="x-small fw-bold text-muted text-uppercase d-block mb-1">Fechamento:</label>
                                                <input 
                                                    type="time" 
                                                    value={horario.fechamento || ""}
                                                    onChange={(e) => handleFechamentoChange(e.target.value, index)}
                                                    className="form-control form-control-sm text-center fw-semibold rounded-3 input-time-custom"
                                                />
                                            </div>
                                        </div>

                                        <button 
                                            type="button" 
                                            onClick={() => alterarHorario(horario.parametro, horario.abertura, horario.fechamento, index)} 
                                            className="btn btn-custom-red btn-sm fw-bold w-100 rounded-3 py-2"
                                            disabled={salvandoIndex === index}
                                        >
                                            {salvandoIndex === index ? (
                                                <span className="spinner-border spinner-border-sm" role="status"></span>
                                            ) : (
                                                <>
                                                    <FaCheck className="me-1" /> Salvar Horário
                                                </>
                                            )}
                                        </button>
                                    </div>
                                ))}
                            </div>
                        )}

                        {/* ESTADO VAZIO */}
                        {!loading && listaHorario.length === 0 && (
                            <div className="text-center py-5">
                                <div className="bg-white p-4 rounded-4 border shadow-xs d-inline-block">
                                    <FaExclamationTriangle className="fs-1 text-warning mb-2" />
                                    <h6 className="fw-bold text-dark m-0">Nenhum Horário Encontrado</h6>
                                    <p className="text-muted small m-0 mt-1">Não foram identificadas configurações de horários registradas.</p>
                                </div>
                            </div>
                        )}

                        {/* BOTÃO DE NAVEGAÇÃO RÁPIDA */}
                        <div className="d-flex justify-content-end mt-3">
                            <Link to="/arbor/sap/" className="btn btn-outline-secondary px-4 fw-semibold rounded-3">
                                Voltar para Solicitações
                            </Link>
                        </div>

                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
}

export default SapSol;